import { Component, OnInit } from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { OtherService } from 'src/app/services/other.service';

import { AccountService } from 'src/app/services/account.service';

import {
  catchError,
  fromEvent,
  interval,
  map,
  of,
  Subject,
  take,
  takeUntil,
  takeWhile,
} from 'rxjs';

import { MobilePhoneNumberService, NationalCodeService } from 'ngx-persian';

import { MapService } from 'src/app/services/map.service';

import { Title } from '@angular/platform-browser';

declare var bootstrap: any;

@Component({
  selector: 'app-login',

  templateUrl: './login.component.html',

  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  Info: any;

  lst_States: any = [];

  list_City: any = [];

  lst_FloatingType: any = [];

  isLoading: boolean = true;

  bSendOtp: boolean = false;

  bLoginMode: boolean = true;

  isFromLoginForm: boolean = false;

  carTypes$ = this.accountService.tankerGPSType().pipe(
    map((response: string) => JSON.parse(response)),
    catchError(() => of(false)),
  );

  isFromAnotherComponent: boolean = true;

  rulesRead: boolean = false;

  openMap: boolean = false;

  isLogin: boolean;

  otpTimer: any | number = 0;

  redirectTo: string;

  redirectTo_id: number | string | null = null;

  valid_MaxLength: number = 11;

  valid_PlaceHolder: number = (<any>window).mobileInputPlaceholder;

  private persianRegex = /^[\u0600-\u06FF\s]$/;

  forceAddress: boolean = false;

  addressPlaceHolder: string = '';

  signUpModel: FormGroup = this.formBuilder.group({
    strName: new FormControl('', Validators.required),
    strFamily: new FormControl('', Validators.required),
    strID: new FormControl('', Validators.required),
    strStateCode: new FormControl('', Validators.required),
    strCity: new FormControl('', Validators.required),
    strMobile: new FormControl('', Validators.required),
    strTel: new FormControl('', Validators.required),
    strAddress: new FormControl(''),
    fLat: new FormControl(0),
    fLon: new FormControl(0),
    strVIN: new FormControl(''),
    tiGPSType: new FormControl(null, Validators.required),
    strComment: new FormControl(''),
    strOtp: new FormControl(''),
    strActivateCode: new FormControl(''),
    strLicenseImage: new FormControl(''),
    strLicenseNo: new FormControl(''),
    rules: new FormControl(false),
    plak4: new FormControl('', [
      Validators.required,
      Validators.maxLength(2),
      Validators.pattern(/^[1-9][0-9]$/),
    ]),
    plak3: new FormControl('', [
      Validators.required,
      Validators.maxLength(3),
      Validators.pattern(/^[1-9][0-9][0-9]$/),
    ]),
    plak2: new FormControl('', [Validators.required]),
    plak1: new FormControl('', [
      Validators.required,
      Validators.maxLength(2),
      Validators.pattern(/^[1-9][0-9]$/),
    ]),
  });

  mdl_Map: FormGroup = this.formBuilder.group({
    strAddress: new FormControl(''),
    fLon: new FormControl(''),
    fLat: new FormControl(''),
    strSource: new FormControl(''),
  });

  unSubscribeAll$ = new Subject<void>();

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private otherService: OtherService,
    private _NationalCode: NationalCodeService,
    private _MobileService: MobilePhoneNumberService,
    private _MapService: MapService,
    private title: Title,
  ) {
    this.addressPlaceHolder = this.forceAddress
      ? '* آدرس محل نصب (الزامی)'
      : 'آدرس محل نصب (اختیاری)';
  }

  ngOnInit(): void {
    this.title.setTitle(
      'ورود به حساب کاربری | TankerGPS - ردیاب تانکر های آبرسان',
    );

    this.signUpModel.patchValue({
      // strMobile: '09015801837'
    });

    if (this.forceAddress) {
      const address = this.signUpModel.get('strAddress');
      address?.addValidators(Validators.required);
      address?.updateValueAndValidity();

      const fLat = this.signUpModel.get('fLat');
      fLat?.addValidators(Validators.required);
      fLat?.updateValueAndValidity();

      const fLon = this.signUpModel.get('fLon');
      fLon?.addValidators(Validators.required);
      fLon?.updateValueAndValidity();
    }

    // صفحه ریدایرکت

    this.route.paramMap.pipe(take(1)).subscribe((params) => {
      this.redirectTo = params.get('redirectTo');
    });
  }

  ngOnDestroy(): void {
    this.unSubscribeAll();
  }

  get isSubmitDisabled() {
    const code = this.signUpModel.get('strActivateCode')?.value || '';

    const mobile = this.signUpModel.get('strMobile')?.value || '';

    // حالت: تایید OTP

    if (this.bSendOtp && !this.bLoginMode) {
      return code === '' || code.length < 4;
    }

    // حالت: لاگین

    if (!this.bSendOtp && this.bLoginMode) {
      return (
        mobile === '' ||
        mobile.length !== this.valid_MaxLength ||
        !this.rulesRead
      );
    }

    // حالت: ثبت‌ نام

    if (!this.bSendOtp && !this.bLoginMode) {
      return false;

      return !this.rulesRead || this.signUpModel.invalid;
    }

    return false;
  }

  get isSignUpMode() {
    return !this.bLoginMode && !this.bSendOtp;
  }

  get isLoginMode() {
    return this.bLoginMode && !this.bSendOtp;
  }

  get isOtpMode() {
    return this.bSendOtp && !this.bLoginMode;
  }

  get otpMessage() {
    const mobile = this.signUpModel.get('strMobile')?.value;

    return `کد به شماره ${mobile} پیامک شد.`;
  }

  initialize() {
    if (!this.lst_States.length) {
      this.accountService
        .GetState()
        .pipe(takeUntil(this.unSubscribeAll$))
        .subscribe((response) => {
          let res = JSON.parse(response.toString());

          this.lst_States = res;
        });
    }

    if (!this.lst_FloatingType.length) {
      this.accountService
        .floatingType()
        .pipe(takeUntil(this.unSubscribeAll$))
        .subscribe((response) => {
          let res = JSON.parse(response.toString());

          this.lst_FloatingType = res;
        });
    }
  }

  changeNumber() {
    this.bSendOtp = false;

    this.bLoginMode = true;

    this.isFromLoginForm = false;

    this.signUpModel.get('strMobile')?.enable();
    this.signUpModel.get('strMobile')?.reset();
  }

  onSubmit() {
    if (this.bLoginMode) {
      this.login_User();

      return;
    }

    if (!this.bSendOtp && !this.bLoginMode) {
      this.signUp_User();

      return;
    }

    if (this.bSendOtp && !this.bLoginMode) {
      this.check_Otp();

      return;
    }
  }

  open_SigUpModal() {
    this.bLoginMode = true;

    this.bSendOtp = false;

    this.isFromLoginForm = false;

    this.signUpModel.get('strMobile').enable();

    var myModal = new bootstrap.Modal(
      document.getElementById('exampleModal'),
      {},
    );

    myModal.show();
  }

  login_User() {
    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,
    };

    if (
      model.strMobile.trim() == '' ||
      model.strMobile.length < this.valid_MaxLength ||
      model.strMobile.length > this.valid_MaxLength
    ) {
      return this.accountService.toastSwal(
        'error',
        'شماره موبایل را به درستی وارد کنید',
      );
    }

    const mobileRegex = /^09\d{9}$/;

    if (!mobileRegex.test(model.strMobile)) {
      return this.accountService.toastSwal(
        'error',
        'شماره موبایل وارد شده صحیح نمی باشد',
      );
    }
    else {
      this.accountService
        .checkMobile(model)
        .pipe(takeUntil(this.unSubscribeAll$))
        .subscribe((data) => {
          let res = JSON.parse(data.toString());

          // اگر حساب کاربری داشت

          if (res[0]?.iPreregistration) {
            this.bLoginMode = false;

            this.bSendOtp = true;

            this.isFromLoginForm = true;

            this.signUpModel.get('strMobile').disable();

            setTimeout(() => {
              this.startOtp_Timer();
            }, 10);

            return;
          }

          //  اگر ثبت نام نکرده بود
          else {
            this.initialize();

            this.isFromLoginForm = false;

            this.bLoginMode = false;

            this.bSendOtp = false;

            this.markAllAsUnTouched(this.signUpModel);

            this.signUpModel.patchValue({
              strName: '',

              strFamily: '',

              strID: '',

              strStateCode: '',

              strCity: '',

              strAddress: '',

              fLat: 0,

              fLon: 0,

              strComment: '',

              strOtp: '',

              strActivateCode: '',
            });

            // this.signUpModel.get('strMobile')?.disable();
          }
        });
    }
  }

  signUp_User() {
    let model = this.signUpModel.value;

    this.markAllAsTouched(this.signUpModel);

    if (this.signUpModel.invalid) {
      return this.accountService.toastSwal(
        'error',
        'فیلدهای ضروری را تکمیل کنید',
      );
    }

    if (this.signUpModel.get('strLicenseImage')?.value == '') {
      return this.accountService.toastSwal('error', 'تصویر مجوز را آپلود کنید');
    }

    if (model.strID && model.strID?.length !== 10) {
      return this.accountService.toastSwal('error', 'کد ملی باید 10 رقم باشد');
    }

    if (model.strID && !this._NationalCode.isValid(model.strID)) {
      return this.accountService.toastSwal(
        'error',
        'کد ملی وارد شده صحیح نمی باشد',
      );
    }

    if (this.forceAddress && (model.fLat == 0 || model.fLon == 0)) {
      return this.accountService.toastSwal(
        'error',
        'آدرس را از روی نقشه انتخاب کنید',
      );
    }

    const formValue = this.signUpModel.value;

    const strVehicleNo = `${formValue.plak1} ${formValue.plak2} ${formValue.plak3} | ${formValue.plak4}`;

    delete formValue.plak1;

    delete formValue.plak2;

    delete formValue.plak3;

    delete formValue.plak4;

    this.accountService
      .register(this.setEmptyString4NullValues({ ...formValue, strVehicleNo }))
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((data) => {
        let res = JSON.parse(data.toString());

        if (res.iResult == 0) {
          return this.accountService.toastSwal('error', res.strError);
        }

        this.bSendOtp = true;

        this.signUpModel.get('strMobile').disable();

        setTimeout(() => {
          this.startOtp_Timer();
        }, 10);
      });
  }

  startOtp_Timer() {
    const TOTAL_SECONDS = 119;

    const changeNumber_btn = document.getElementById('changeNumber-btn');

    const onChangeNumberClicked$ = fromEvent(changeNumber_btn, 'click');

    interval(1000)
      .pipe(
        takeWhile((value) => value <= TOTAL_SECONDS),
        takeUntil(onChangeNumberClicked$),
      )
      .subscribe({
        next: (value) => {
          const remaining = TOTAL_SECONDS - value;

          const minutes = Math.floor(remaining / 60)
            .toString()
            .padStart(2, '0');

          const seconds = (remaining % 60).toString().padStart(2, '0');

          this.otpTimer = `${minutes}:${seconds}`;
        },

        error: (err) => console.error(err),

        complete: () => (this.otpTimer = 0),
      });
  }

  check_Otp() {
    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,

      iOTP: this.signUpModel.get('strActivateCode')?.value,
    };

    this.accountService
      .otpCheck(model)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((userData) => {
        let resParse = JSON.parse(userData.toString());

        if (resParse.iResult == 0)
          return this.accountService.toastSwal('error', resParse.strError);

        this.accountService.toastSwal('success', ` خوش آمدید`);

        var data = {
          Id: resParse[0].iPreregistration,

          session: resParse[0].strSession,
        };
        sessionStorage.setItem('info', JSON.stringify(data));

        if (this.isFromAnotherComponent) {
          if (this.redirectTo_id) {
            return this.router.navigate([
              `/${this.redirectTo}/${this.redirectTo_id}`,
            ]);
          } else this.router.navigate([`/${this.redirectTo}`]);
        }

        this.otherService.changeUserLogin_Status(true);
      });
  }

  checkRules(e) {
    this.rulesRead = e.target.checked;
  }

  sendAgain_Otp() {
    var model = {
      strMobile: this.signUpModel.get('strMobile')?.value,
    };

    this.accountService
      .otpAgain(model)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((data) => {
        let res = JSON.parse(data.toString());

        if (res.bError)
          return this.accountService.toastSwal('error', res.strError);

        this.accountService.toastSwal('success', 'کد جدید ارسال شد');

        setTimeout(() => {
          this.startOtp_Timer();
        }, 10);
      });
  }

  backTo_ChangeNumber() {
    this.bSendOtp = false;
  }

  dismissModal() {
    if (this.isFromAnotherComponent) this.router.navigate(['/home']);

    let myModal = document.getElementById('exampleModal');

    var modal = bootstrap.Modal.getInstance(myModal);

    modal.hide();

    this.bLoginMode = true;

    this.bSendOtp = false;

    this.isFromLoginForm = false;

    this.signUpModel.get('strMobile').enable();
  }

  setEmptyString4NullValues(obj: any) {
    for (const key in obj) {
      if (obj[key] === null) obj[key] = '';
    }

    return obj;
  }

  getCity(id) {
    this.accountService
      .GetCity(id)
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((response: any) => {
        let res = JSON.parse(response.toString());

        if (res.iResult == 0)
          return this.accountService.toastSwal('error', res.strError);

        this.signUpModel.get('strCity')?.setValue('');

        this.list_City = res;
      });
  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }

  openAdd() {
    window.open(`/general`, '_blank');
  }

  show_Map() {
    let model = this.signUpModel.value;

    const { strCity, strAddress } = model;

    const cityObj = this.list_City.find((c) => c.strCity === strCity);

    if (model.strAddress == '') {
      this._MapService
        .getCurrentLocation()
        .then((coords) => {
          this.mdl_Map.patchValue({
            strAddress: '',

            fLon: coords.longitude || 0,

            fLat: coords.latitude || 0,

            strSource: 'strAddress',
          });

          this.openMap = true;
        })
        .catch((error) => {
          this.mdl_Map.patchValue({
            strAddress: '',

            fLon: model.fLon || 0,

            fLat: model.fLat || 0,

            strSource: 'strAddress',
          });

          this.openMap = true;

          console.error('Error getting location:', error);
        });
    } else {
      this.mdl_Map.patchValue({
        strAddress: this.baseAddress(),

        fLon: cityObj.fLon || 0,

        fLat: cityObj.fLat || 0,

        strSource: 'strAddress',
      });

      this.openMap = true;
    }
  }

  baseAddress(): string {
    const { strCity, strAddress } = this.signUpModel.value;

    const cityObj = this.list_City.find((c) => c.strCity === strCity);

    if (!cityObj) return strAddress?.trim() ?? '';

    const cityName = cityObj.strCityName?.trim();

    if (!cityName) return strAddress?.trim() ?? '';

    const normalizedAddress = strAddress?.trim() ?? '';

    if (normalizedAddress.startsWith(cityName)) {
      return normalizedAddress;
    }

    return `${cityName}، ${normalizedAddress}`;
  }

  submitMap(event: any) {
    this.openMap = false;

    if (event.strText != '') {
      this.signUpModel.patchValue({
        strAddress: event.strText,

        fLon: event.longitude,

        fLat: event.latitude,
      });
    } else {
      this.signUpModel.patchValue({
        strAddress: '',

        fLon: 0,

        fLat: 0,
      });
    }
  }

  onFileSubmit(event) {
    if (event.strFile) {
      const reader: any = new FileReader();

      reader.readAsDataURL(event.strFile);

      reader.onload = async () => {
        var base64String = reader.result.toString();

        this.signUpModel.patchValue({
          strLicenseImage: base64String.replace('data:image/jpeg;base64,', ''),
        });
      };
    } else {
      this.signUpModel.patchValue({
        strLicenseImage: '',
      });
    }
  }

  onlyNumber(e: KeyboardEvent) {
    if (
      e.ctrlKey ||
      e.metaKey ||
      /[0-9]/.test(e.key) ||
      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
    ) {
      return;
    }

    e.preventDefault();
  }

  onlyPersian(e: KeyboardEvent) {
    const controlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End',
    ];

    if (e.ctrlKey || e.metaKey || controlKeys.includes(e.key)) {
      return;
    }

    if (!this.persianRegex.test(e.key)) {
      e.preventDefault();
    }
  }

  sanitizePersian(e: any) {
    const value = e.target.value;
    e.target.value = value.replace(/[^\u0600-\u06FF\s]/g, '');
  }

  unSubscribeAll(): void {
    this.unSubscribeAll$.next();

    this.unSubscribeAll$.complete();
  }
}
